
export const OK = 200
export const CREATED = 201
export const INTERNAL_SERVER_ERROR = 500
//Laravelのバリデーションエラーレスポンス
export const UNPROCESSABLE_ENTITY = 422
export const UNAUTHORIXED = 401
export const BAD_REAUEST = 400

export const LoginMsg = "ログイン認証中..."
export const LogoutMsg = "ログアウト中..."
export const RegisterMsg = "ユーザー作成中..."
export const ServerLoading = "サーバー通信中..."